// Extracted styles for <workflow-agent> component
import { css } from 'lit';

export const workflowAgentStyles = css`
  :host {
    display: block;
    --assistant-bg: var(--color-agent-assistant-bg);
    --user-bg: var(--color-agent-user-bg);
    --tool-bg: var(--color-agent-tool-bg);

    --text-light: var(--color-agent-text-light);
    --text-dark: var(--color-agent-text-dark);
    font: var(--font);
    font-size: 12px;
    width: 100%;
    height: 100%;
    min-height: 0;
  }
  .steps {
    max-height: calc(100vh - 240px);
    overflow: auto;
    padding-right: 2px;
  }
  .assistant,
  .user,
  .tool {
    margin: 0.5rem;
    display: flex;
    flex-direction: column;
  }
  .assistant .content,
  .user .content,
  .tool .content {
    padding: 0.6rem 0.9rem;
    border-radius: var(--spectrum-corner-radius-100);
    max-width: 70ch;
    white-space: pre-wrap;
  }
  .assistant .content {
    background: var(--assistant-bg);
    color: var(--text-dark);
    margin-right: auto;
  }
  .user .content {
    background: var(--spectrum-gray-400, #6e6e6e);
    color: #fff;
    margin-left: auto;
    text-align: right;
  }
  .tool .content {
    background: var(--tool-bg);
    color: var(--text-light);
    margin-right: auto;
  }
  .thinking .typing {
    display: inline-flex;
    align-items: center;
    height: 17px;
  }
  .thinking .dot {
    display: inline-block;
    width: 5px;
    height: 5px;
    margin-right: 4px;
    border-radius: 50%;
    vertical-align: middle;
    background: var(--color-chat-placeholder-text, #888);
    opacity: 0.55;
    animation: mercury-typing 1.8s infinite ease-in-out;
  }
  .thinking .dot:nth-child(1) { animation-delay: 200ms; }
  .thinking .dot:nth-child(2) { animation-delay: 300ms; }
  .thinking .dot:nth-child(3) { margin-right: 0; animation-delay: 400ms; }
  @keyframes mercury-typing {
    0%, 44%, 100% { transform: translateY(0); opacity: 0.45; }
    28% { transform: translateY(-7px); opacity: 0.9; }
  }

  .reasoning {
    display: block;
    margin-top: 0.4rem;
    padding: 0.4rem 0.6rem;
    opacity: 0.8;
    border-left: 3px solid var(--color-agent-reasoning-border);
    background: var(--assistant-bg);
    border-radius: var(--spectrum-corner-radius-100);
  }

  .goal-wrapper {
    position: relative;
    --mod-textfield-width: 100%;
    margin-top: 10px;
  }
  .goal-wrapper sp-action-button {
    font-size: 1.5rem;
    position: absolute;
    top: 10px;
    right: 5px;
  }

  .conversations-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 10px;
    border-bottom: 1px solid var(--color-app-border);
  }
  .conversations-title {
    font-size: 13px;
    font-weight: 650;
    color: var(--spectrum-gray-900);
    margin: 0;
  }
  .conversations-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
    max-height: calc(100vh - 200px);
    overflow: auto;
    padding-top: 10px;
  }
  .empty-state {
    display: grid;
    place-items: center;
    min-height: 180px;
    padding: 18px 16px;
    border: 1px dashed var(--color-app-border);
    border-radius: 8px;
    background: var(--color-sidebar-bg);
    color: var(--spectrum-gray-600);
    font-size: 12px;
    line-height: 1.45;
    text-align: center;
  }
  .conversation-row {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 0.25rem;
    text-align: left;
    border: 1px solid var(--color-app-border);
    border-radius: 8px;
    background: var(--color-sidebar-surface);
    color: inherit;
    font: inherit;
  }
  .conversation-row:hover {
    background: var(--color-sidebar-surface-hover);
  }
  .conversation-row-main {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    text-align: left;
    padding: 9px 10px;
    border: 0;
    background: transparent;
    color: inherit;
    font: inherit;
    cursor: pointer;
    min-width: 0;
  }
  .conversation-delete {
    align-self: center;
    margin-right: 0.25rem;
    opacity: 0;
    transition: opacity 0.1s ease-in-out;
  }
  .conversation-row:hover .conversation-delete,
  .conversation-row:focus-within .conversation-delete {
    opacity: 1;
  }
  .conversation-delete.confirm {
    opacity: 1;
    --spectrum-actionbutton-icon-color-default: var(
      --spectrum-red-700,
      #d7373f
    );
    color: var(--spectrum-red-700, #d7373f);
  }
  .conversation-row.status-waiting_approval {
    border-left: 3px solid var(--spectrum-orange-500, #e68619);
  }
  .conversation-row.status-failed {
    border-left: 3px solid var(--spectrum-red-500, #d7373f);
  }
  .conversation-row.status-running,
  .conversation-row.status-queued {
    border-left: 3px solid var(--spectrum-blue-500, #2680eb);
  }
  .conversation-goal {
    color: var(--spectrum-gray-900);
    font-size: 12px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .conversation-subtitle {
    font-size: 11px;
    color: var(--spectrum-gray-600);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .conversation-meta {
    display: flex;
    gap: 0.5rem;
    font-size: 10px;
    color: var(--spectrum-gray-500);
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  .conversation-status {
    font-weight: 600;
  }

  .detail-header {
    display: flex;
    align-items: center;
    padding: 0.25rem 0.25rem 0.5rem;
  }

  .approval-banner {
    border-top: 2px solid var(--spectrum-orange-500, #e68619);
    background: var(--spectrum-gray-200);
    padding: 0.85rem 0.9rem 0.75rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .approval-title {
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.35rem;
  }
  .approval-title::before {
    content: '⚠';
    font-size: 13px;
    color: var(--spectrum-orange-500, #e68619);
  }
  .approval-plan-text {
    font-size: 12px;
    line-height: 1.5;
    opacity: 0.85;
  }
  .approval-ops {
    margin: 0;
    padding-left: 1.1rem;
    font-size: 11px;
    line-height: 1.6;
    opacity: 0.75;
  }
  .approval-actions {
    display: flex;
    gap: 0.5rem;
    padding-top: 0.25rem;
  }
`;
